import React from "react";
import { AddTenantContextProvider } from "./AddTenantView";
import AddTenant from "./views/AddTenant";

const AddTenantPage = () => {
  return (
    <AddTenantContextProvider>
      <AddTenant />
    </AddTenantContextProvider>
  );
};

export default AddTenantPage;
